import React from 'react';
import { classNames } from "../../helpers/classNames";

const TitleDecoration = ({classes}) => {
  const data = [
    { _id: 1, classes: "bg-gradient-to-tr from-red to-orange animate-decoration-01" },
    { _id: 2, classes: "bg-gradient-to-tr from-indigo to-purple animate-decoration-02" },
    { _id: 3, classes: "bg-gradient-to-tr from-green to-yellow animate-decoration-03" },
  ]
  return (
    data?.length > 0 && (
      <div className={classNames("flex items-center justify-center gap-1", classes)}>
        {data?.map((item, index) => (
          <div key={index} className={classNames("w-3 rounded-full aspect-square", item?.classes)} />
        ))}
      </div>
    )
  );
};

export default TitleDecoration;